import AppealController from "@/controllers/Organizations/AppealController";
import AppealOrganizationController from "@/controllers/Organizations/AppealOrganizationController";

export default {
  namespaced: true,
  state: {
    appealsData: {data: [], counter: 0},
    appealsLoading: false,
    appealsError: null,
    orgAppealsData: {data: [], counter: 0},
    orgAppealsLoading: false,
    orgAppealsError: null,
  },
  actions: {
    async getAllAppealsFormsFive({commit}) {
      try {
        commit('SET_DATA_SPR_LOADING', {data: true, name: 'appeals'})
        const res = await AppealController.getAppeals();
        if (res) {
          commit('SET_DATA_SPR', {data: res, name: 'appeals'})
          commit('SET_DATA_SPR_LOADING', {data: false, name: 'appeals'})
        }
      } catch (e) {
        console.error('appeals', e.message)
        commit('SET_DATA_SPR_ERROR', {data: e.message, name: 'appeals'})
      }

    },
    async getAllOrganizationAppeals({commit, state}) {
      try {
        if (state.orgAppealsLoading)
          return;
        commit('SET_DATA_SPR_LOADING', {data: true, name: 'orgAppeals'})
        const res = await AppealOrganizationController.getAppeals();
        if (res) {
          commit('SET_DATA_SPR', {data: res, name: 'orgAppeals'})
          commit('SET_DATA_SPR_LOADING', {data: false, name: 'orgAppeals'})
        }
      } catch (e) {
        console.error('orgAppeals', e.message);
        commit('SET_DATA_SPR_ERROR', {data: e.message, name: 'orgAppeals'});
        commit('SET_DATA_SPR_LOADING', {data: false, name: 'orgAppeals'});
      }
    },
    pushNewElement({commit}, payload) {
      commit('PUSH_NEW_DATA', payload);
    },
    pushOrgAppeal({commit}, payload) {
      commit('PUSH_ORG_APPEAL_DATA', payload);
    },
    deleteOrgAppeal({commit}, id) {
      commit('DELETE_ORG_APPEAL_DATA', id);
    }
  },
  mutations: {
    ['SET_DATA_SPR'](state, payload) {
      state[payload.name + 'Data'] = {data: payload.data, counter: payload.data.length};
    },
    ['PUSH_NEW_DATA'](state, payload) {
      const checkDouble = state.appealsData.data.findIndex(el => el.id === payload.id);
      if (checkDouble === -1)
        state.appealsData.data.push(payload);
      else
        state.appealsData.data.splice(checkDouble, 1, payload);
    },
    ['PUSH_ORG_APPEAL_DATA'](state, payload) {
      const checkDouble = state.orgAppealsData.data.findIndex(el => el.id === payload.id);
      if (checkDouble === -1)
        state.orgAppealsData.data.push(payload);
      else
        state.orgAppealsData.data.splice(checkDouble, 1, payload);
    },
    ['DELETE_ORG_APPEAL_DATA'](state, payload) {
      const ind = state.orgAppealsData.data.findIndex(el => el.id === payload);
      state.orgAppealsData.data.splice(ind, 1);
    },
    ['SET_DATA_SPR_LOADING'](state, payload) {
      state[payload.name + 'Loading'] = payload.data;
    },
    ['SET_DATA_SPR_ERROR'](state, payload) {
      state[payload.name + 'Error'] = payload.data;
    }
  },
  getters: {
    get_appeals_data(state) {
      return state.appealsData;
    },
    get_appeals_loading(state) {
      return state.appealsLoading;
    },
    get_appeals_error(state) {
      return state.appealsError;
    },
    get_org_appeals_data(state) {
      return state.orgAppealsData;
    },
    get_org_appeals_loading(state) {
      return state.orgAppealsLoading;
    },
    get_org_appeals_error(state) {
      return state.orgAppealsError;
    },
  }
}